module.exports = __webpack_public_path__ + "img/colx.94b57c1d.svg";